import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ApprovalRequest} from "@app/shared/approval-status/approval-status";
import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {Transaction} from "@app/shared/enums/txn-type.enum";
import {TxnErrorCodeRequest} from "@app/shared/txn-error-code/txn-error-code";
import {plainToClass} from "class-transformer";
import {SalaryHistory} from "@app/shared";

/**
 * This shared component shows approval status or submission validation errors for a transaction given its type, refId and currentStatus
 * @author Jin C
 */
@Component({
  selector: 'app-approvable-status',
  templateUrl: './approvable-status.component.html',
  styleUrls: ['./approvable-status.component.css']
})
export class ApprovableStatusComponent implements OnInit, OnChanges {

  @Input()
  transaction: Transaction;

  @Input()
  refId: number;

  @Input()
  currentStatus: ApprovalStatusType;          // if ACTION_REQUIRED, allow viewing of submission validation errors

  @Input()
  hasSubmissionError: boolean;                // if true, allow viewing of submission validation errors

  @Input()
  approvalTooltip: string;

  @Input()
  validationTooltip: string;

  @Input()
  showStatusInDialog?: boolean = true;

  @Input()
  showStatusOnPage?: boolean = false;

  @Input()
  showCurrentStatus: boolean = true;          // if false, do not show currentStatus e.g. recruit-to-hire show the status and has separate click action

  @Input()
  emitStatus?: boolean = false;

  @Input()
  managingOrgId: number;

  DefaultApprovalTooltip: string = "View Approval Status";
  DefaultValidationTooltip: string = "View Submission Error";
  ApprovalStatusType: typeof ApprovalStatusType = ApprovalStatusType;

  approvalStatusRequest: ApprovalRequest;     // input object to make a call to approval-status common component
  txnErrorCodeRequest: TxnErrorCodeRequest;   // displays the txn error codes common component



  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.approvalTooltip) {this.approvalTooltip = this.DefaultApprovalTooltip; }
    if (!this.validationTooltip) {this.validationTooltip = this.DefaultValidationTooltip; }
  }

  /**
   * @desc show approval status of the input transaction by calling the app-approval-status component
   */
  onClickShowApprovalStatusDialog(transaction: Transaction, refId: number, showStatusInDialog: boolean, showStatusOnPage: boolean, emitStatus: boolean) {
    this.approvalStatusRequest = new ApprovalRequest();
    this.approvalStatusRequest.transaction = transaction;
    this.approvalStatusRequest.refId = refId;
    this.approvalStatusRequest.showStatusInDialog = showStatusInDialog;
    this.approvalStatusRequest.showStatusOnPage = showStatusOnPage;
    this.approvalStatusRequest.emitStatus = emitStatus;
  }

  /**
   * @desc show validation error of the input transaction by calling the app-txn-error-code component
   */
  onClickShowValidationError(transaction: Transaction, refId: number, showStatusInDialog: boolean, showStatusOnPage: boolean, emitStatus: boolean) {
    this.txnErrorCodeRequest = new TxnErrorCodeRequest();
    this.txnErrorCodeRequest.txnType = transaction;
    this.txnErrorCodeRequest.refId = refId;
    this.txnErrorCodeRequest.showStatusInDialog = showStatusInDialog;
    this.txnErrorCodeRequest.showStatusOnPage = showStatusOnPage;
    this.txnErrorCodeRequest.emitStatus = emitStatus;
  }
}
